import { createFileRoute } from '@tanstack/react-router'
import { TermosBCPage } from '@/features/background-check/pages/termos-bc'

export const Route = createFileRoute('/termos-bc')({
  component: TermosBCPage,
})
